import React from 'react';

import Loading from "../../../Global/Loading";
import ClassProgressTableField from './ClassProgressTableField';
import ClassProgressRow from "./ClassProgressRow";
import { states } from '../../values/enums';

export default function ClassProgressContent(props) {
  const {status, reportData, isBenchmarkOnly, scaleId} = props;

  if (status === states.ERROR) {
    return (
      <div className="filler-text">
        Error: unable to retrieve class progress report.
      </div>
    );
  }
  
  if (!status || status === states.PENDING) {
    return (
      <div className="loaderStyle">
        <Loading />
      </div>
    );
  }

  const reportDataRows = reportData.map(({studentId, scores, selectedBenchmark, selectedLocale}, index) => (
    <ClassProgressRow key={`class-progress-${studentId}`} scores={scores} rowNum={index} isBenchmarkOnly={isBenchmarkOnly} benchmarkGrade={selectedBenchmark?.grade} benchmarkName={selectedBenchmark?.label} selectedLocale={selectedLocale}/>
  ));

  return (
    <div className="classProgressReportContent">
      <div className="classProgressTableHeaders">
        <div className="classProgressTableSpacer"/>
        <div className="classProgressTableFieldContainer">
          <ClassProgressTableField fieldTitle="Fall (BOY)" scale={scaleId} isBenchmarkOnly={isBenchmarkOnly}/>
          <ClassProgressTableField fieldTitle="Winter (MOY)" scale={scaleId} isBenchmarkOnly={isBenchmarkOnly}/>
          <ClassProgressTableField fieldTitle="Spring (EOY)" scale={scaleId} isBenchmarkOnly={isBenchmarkOnly}/>    
        </div>
      </div>
      <div className="classProgressTableRows">
        {reportDataRows}
      </div>
    </div>
  );
}
